import React from 'react';
import PagosRealizadosTable from './TablePagosRealizados/TablePagosRealizados';

const PagosRealizados = () => {
  return <PagosRealizadosTable/> ;
};

export default PagosRealizados;
